module.exports = __webpack_public_path__ + "img/618cd59.png";